import { Image, Text, UnstyledButton, disabledStyle } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { styled } from "styled-components";

import { supportedConnectorMap } from "./connector-full-logo.const";

type StyledConnectorFullLogoProps = {
  connected?: any;
  ariaLabel?: any;
};

export type ConnectorFullLogoProps = StyledConnectorFullLogoProps & {
  key?: string | number;
  connectorName: string;
  alt?: string;
  disabled?: boolean;
};

export const ConnectorFullLogoButton = styled(UnstyledButton)`
  border-radius: var(--defaults-borderRadius);
  border: 1px solid var(--palette-border-neutral-subtle);
  background-color: var(--palette-bg-neutral-base);
  display: flex;
  align-items: center;
  justify-content: center;
  height: 96px;
  width: 100%;
  padding: var(--sizes-spacing-7);
  border-width: 1px;
  border-radius: 8px;
  outline: 0;
  cursor: unset;

  @media (max-width: 640px) {
    padding: var(--sizes-spacing-4);
    height: 72px;
  }

  &:hover,
  &.active {
    border-color: var(--palette-border-neutral-subtle);
  }

  &:disabled {
    ${disabledStyle}
  }
`;

export const ConnectorFullLogoButtonWithHover = styled(ConnectorFullLogoButton)`
  cursor: pointer;
  &:hover,
  &.active {
    border-color: var(--palette-content-status-positive);
    box-shadow: 0 0 3px var(--palette-content-status-positive);
  }
`;

export const StyledConnectorFullLogo = styled(Image)`
  width: 100%;
  max-width: 200px;
  max-height: 40px;
`;

export const ConnectorTextContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const ConnectorFullLogo = ({ connectorName, alt = "", ariaLabel = "", ...other }: ConnectorFullLogoProps) => {
  const intl = useIntl();
  return connectorName === "Codat Accounting" ? (
    <ConnectorTextContainer>
      <Text>{intl.formatMessage({ id: "shared-ui: Other software...", defaultMessage: "Other software..." })}</Text>
    </ConnectorTextContainer>
  ) : (
    <StyledConnectorFullLogo
      {...other}
      src={supportedConnectorMap[connectorName]}
      alt={alt}
      title={connectorName}
      aria-label={ariaLabel}
    />
  );
};
